import { ChevronRightIcon } from '@heroicons/react/20/solid'
import PropTypes from 'prop-types'

const SimpleDefinitionListItem = ({ 
  caption, 
  children = null, 
  description = null, 
  icon = null, 
  isLink = false,
  onPress = () => {},
  showBorder = true,
}) => (
  <div 
    className={`flex flex-wrap items-center justify-between px-2 py-3 ${showBorder ? 'border-dotted border-b-1 border-gray-300 dark:border-content2-foreground' : ''} gap-y-2 ${isLink ? 'cursor-pointer' : ''}`}
    onClick={() => isLink && onPress()}
  >
    <div className="flex items-center">
      {icon && <div className="w-6 h-6 mr-3 text-indigo-800 dark:text-content2-foreground">{icon}</div>}
      <h3 className="mr-8">{caption}</h3>
    </div>
    
    <div className='flex items-center'>
      {description !== null && <p className="font-semibold text-content2-foreground">{description}</p>}
      {children}
      {isLink && <ChevronRightIcon className="text-white w-7 h-7 ml-7" />}
    </div>
  </div>
)

SimpleDefinitionListItem.propTypes = {
  icon: PropTypes.node,
  isLink: PropTypes.bool,
  caption: PropTypes.string.isRequired,
  children: PropTypes.node,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onPress: PropTypes.func,
  showBorder: PropTypes.bool,
}

export default SimpleDefinitionListItem